/** 设置 → 规划 → 通知、发送日志和电子邮件偏好（规划 P4-1a，设计 §5.7、§5.8）。 */
export default {
  notifications: {
    title: '通知',
    description:
      '就案件动态向申请人、官员和技术部门发送电子邮件。邮件只包含编号、日期、步骤名称、议会名称和链接，不含其他内容。',
    enabled: '发送电子邮件通知',
    enabledHint: '默认关闭。只有开启之后发生的事项才会发送邮件。',
    enableNeedsTest: '请先使用下方按钮向自己发送一封测试邮件。',
    enabledSince: '自 {{date}} 起开启。',
    modesTitle: '每种邮件的发送方式',
    kinds: {
      applicant_update: '给申请人的更新',
      applicant_document_shared: '与申请人共享的文件',
      applicant_reminder: '给申请人的提醒',
      officer_work: '给官员的工作',
      officer_referral_answered: '已收到技术意见',
      officer_reminder: '给官员的提醒',
      department_referral: '技术意见请求',
      department_reminder: '给部门的提醒',
      test: '测试邮件',
      digest: '每日摘要',
    },
    modes: { off: '关闭', immediate: '立即发送', digest: '放入每日摘要' },
    offsetsTitle: '提醒',
    offsetsHint: '日期之前的天数，用逗号分隔。',
    offsetsApplicant: '回复日期之前的天数',
    offsetsLapse: '许可失效之前的天数',
    appealDates: '包含上诉日期',
    appealDatesHint: '关闭时，邮件和提醒不会提及上诉期限。',
    digestHour: '每日摘要的时间（0 至 23 点）',
    defaultLocale: '用户未选择时使用的语言',
    locales: { en: '英语', ms: '马来语', zh: '中文' },
    replyTo: '回复地址',
    replyToHint: '回复将发送到此邮箱，例如议会的 OSC 邮箱。',
    problems: {
      offsets: '{{min}} 至 {{max}} 的整数天数，最多三个，不可重复。',
      digestHour: '请输入 0 至 23 的整点。',
      replyTo: '请输入一个电子邮件地址。',
    },
    save: '保存通知设置',
    saving: '正在保存…',
    saved: '通知设置已保存。',
    log: {
      title: '发送日志',
      senderLabel: '邮件服务',
      senderSes: '通过 Amazon SES 发送',
      senderSmtp: '通过您的邮件中继发送',
      relayNoFeedback: '您的邮件中继不报告退信：“已发送”表示中继已接受该邮件。',
      noRelay: '未配置邮件中继',
      countsLabel: '按状态统计的邮件',
      awaitingDigest: '等待摘要',
      awaitingDigestHint: '摘要邮件在此等待，直到下一封每日摘要发出。',
      held: '等待信函',
      heldListLabel: '等待信函的决定',
      heldItem: '{{caseRef}}：第 {{step}} 步的决定',
      overCap: '超过收件人上限',
      failuresLabel: '按原因统计的失败',
      failure: '{{reason}}：{{count}}',
      filterLabel: '案件编号',
      filter: '筛选',
      clearFilter: '清除筛选',
      columns: {
        kind: '邮件',
        caseRef: '案件',
        recipient: '收件人',
        status: '状态',
        attempts: '尝试次数',
        created: '创建时间',
        action: '操作',
      },
      empty: '尚未记录任何邮件。',
      more: '显示更多',
      resend: '重新发送',
      resendLabel: '重新发送给 {{address}} 的邮件',
    },
    statuses: {
      queued: '排队中',
      sent: '已发送',
      failed: '失败',
      suppressed: '未发送',
      bounced: '被退回',
      complained: '被标记为垃圾邮件',
    },
    codes: {
      not_visible: '此人已无法查看该案件',
      opted_out: '此人已关闭此类邮件',
      no_address: '此人没有电子邮件地址',
      address_suppressed: '此地址曾被退回或投诉',
      not_configured: '未配置邮件中继',
      no_link_base: '没有可链接的控制台地址',
      over_cap: '收件人过多',
      stale: '时间过久，不再发送',
      throttled: '邮件服务要求降低发送速度',
      rejected: '被邮件服务拒绝',
      invalid_address: '地址无效',
      auth_failed: '邮件服务拒绝了凭据',
      timeout: '邮件服务未及时响应',
      unavailable: '无法连接邮件服务',
      unknown: '未知的邮件服务故障',
    },
    test: {
      send: '向我发送测试邮件',
      sending: '正在发送…',
      sent: '测试邮件已发送至 {{address}}。',
      failed: '测试邮件未发送：{{reason}}。',
    },
    unavailable: {
      not_configured: '未配置邮件中继，无法发送测试邮件。',
      no_address: '您的账户没有可接收测试邮件的地址。',
      not_tenant_identity: '您的账户不属于此工作区。请使用此工作区的账户登录后再发送测试邮件。',
      settings_not_saved: '请先保存规划设置，然后再发送测试邮件。',
      no_link_base: '此安装没有可链接的控制台地址，因此任何邮件都无法送达。',
    },
    preferences: {
      open: '电子邮件偏好',
      title: '电子邮件偏好',
      intro: '选择您要接收的规划邮件。关闭邮件不会隐藏控制台中的任何内容。',
      updates: '我的案件更新',
      reminders: '日期提醒',
      digests: '每日摘要',
      lastChanged: '最后更改于 {{date}}。',
      save: '保存',
      saving: '正在保存…',
      cancel: '取消',
    },
  },
  errors: {
    notifications_test_required: '开启通知前，请先向自己发送一封测试邮件。',
    notification_test_unavailable: '无法发送测试邮件：未设置邮件中继，或您的账户没有地址。',
    notification_test_limit: '每小时最多五封测试邮件。请稍后再试。',
    notification_not_found: '未找到该邮件。',
    notification_not_resendable: '只有失败或过期的邮件才能重新发送。',
    notifications_off: '通知已关闭。请先开启通知，再重新发送邮件。',
  },
} as const
